import React, { useState, useEffect } from 'react';
import matter from 'gray-matter';
import { Buffer } from 'buffer';
import CourseCard from './CourseCard';
import CourseFilter from './CourseFilter';

window.Buffer = Buffer;

const Courses = () => {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedTag, setSelectedTag] = useState(null);

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const cacheBust = `?t=${new Date().getTime()}`;
        const manifestRes = await fetch(`/courses-manifest.json${cacheBust}`);
        if (!manifestRes.ok) {
          throw new Error(`Failed to fetch manifest: ${manifestRes.statusText}`);
        }
        const manifest = await manifestRes.json();

        const coursePromises = manifest.map(async (file) => {
          const courseRes = await fetch(`/courses/${file}${cacheBust}`);
          if (!courseRes.ok) {
            console.error(`Failed to fetch course: ${file}`);
            return null;
          }
          const text = await courseRes.text();
          const { data, content } = matter(text);
          return { ...data, content, fileName: file };
        });

        const allCourses = (await Promise.all(coursePromises))
          .filter(Boolean)
          .sort((a, b) => a.priority - b.priority);
        setCourses(allCourses);
      } catch (error) {
        console.error("Error fetching courses:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCourses();
  }, []);

  const allTags = [...new Set(courses.flatMap(course => course.tags || []))];

  const filteredCourses = selectedTag
    ? courses.filter(course => course.tags && course.tags.includes(selectedTag))
    : courses;

  if (loading) {
    return (
      <section id="courses" className="section">
        <h2 className="section-title">Courses</h2>
        <div className="section-content">
          <p>Loading courses...</p>
        </div>
      </section>
    );
  }

  return (
    <section id="courses" className="section">
      <h2 className="section-title">Courses</h2>
      <div className="section-content">
        <p className="courses-intro">
          To ensure high-quality delivery and personalized attention, our training courses are optimized for a maximum of 10 attendees. Custom engagements for larger cohorts are available upon request and will be scoped dynamically to meet your organization's specific requirements.
        </p>
        <CourseFilter 
          tags={allTags} 
          selectedTag={selectedTag} 
          onSelectTag={setSelectedTag} 
        />
        <div className="courses-grid">
          {filteredCourses.map((course) => (
            <CourseCard key={course.fileName} course={course} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Courses;
